import { useLanguage } from "../../../i18n/LanguageContext";

export default function DefinitionListBlock({ block }) {
  const { language } = useLanguage();

  const items = block.content?.items || [];
  const translatedItems =
    block.translated_content?.items || [];

  const getTranslatedItem = (item, index) => {
    if (language === "zh") {
      return item.chinese || null;
    }

    if (language === "es" || language === "ru") {
      return translatedItems[index] || null;
    }

    return null;
  };

  return (
    <div
      style={{
        padding: "18px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {block.title && (
        <h3 style={{ marginTop: 0 }}>
          {block.title}
        </h3>
      )}

      <div style={{ display: "grid", gap: "14px" }}>
        {items.map((item, index) => {
          const translatedItem =
            getTranslatedItem(item, index);

          return (
            <div
              key={index}
              style={{
                paddingBottom: "12px",
                borderBottom:
                  index < items.length - 1
                    ? "1px solid #e5e7eb"
                    : "none",
              }}
            >
              {/* Canonical English */}
              <div style={{ lineHeight: "1.6" }}>
                {item.english}
              </div>

              {/* Selected-language learning aid */}
              {translatedItem && (
                <div
                  style={{
                    marginTop: "5px",
                    color: "#6b7280",
                    lineHeight: "1.6",
                  }}
                >
                  {translatedItem}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}